import { ConsoleNetworkOutlineIcon } from './ConsoleNetworkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 48F71C58-812D-40AA-BC4D-9D4381684E90
 * name console-network-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/console-network-outline.svg
 * tags
 */
export const TerminalNetworkOutlineIcon = ConsoleNetworkOutlineIcon;
export default TerminalNetworkOutlineIcon